import { Controller } from '@hotwired/stimulus'

const ACTIVE_CLASSES = ['text-primary', 'border-primary']
const INACTIVE_CLASSES = ['text-base-content/60', 'border-transparent']

export default class extends Controller {
  static targets = ['tab', 'panel']
  static values = { active: String }

  connect() {
    if (!this.activeValue) {
      const first = this.tabTargets[0]
      this.activeValue = first?.dataset.tabsTabParam || ''
    }
    this.update()
  }

  select(event) {
    event.preventDefault()
    const next = event.currentTarget.dataset.tabsTabParam
    if (next) this.activeValue = next
  }

  activeValueChanged() {
    this.update()
  }

  update() {
    const active = this.activeValue

    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tabsTabParam === active
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false')
      tab.tabIndex = isActive ? 0 : -1
      tab.classList.toggle('font-semibold', isActive)
      ACTIVE_CLASSES.forEach((cls) => tab.classList.toggle(cls, isActive))
      INACTIVE_CLASSES.forEach((cls) => tab.classList.toggle(cls, !isActive))
    })

    this.panelTargets.forEach((panel) => {
      const isActive = panel.dataset.tabsPanelParam === active
      panel.classList.toggle('hidden', !isActive)
    })
  }
}
